export const getEnumKeyByEnumValue = <T extends {[index: string]: string}>(myEnum: T, enumValue: string): keyof T | undefined => {
    const keys = Object.keys(myEnum).filter(x => myEnum[x] === enumValue)

    return keys.length > 0 ? keys[0] : undefined
}

// Narrows an unknown value (e.g. from the API) to one of the values of a string enum
export const isEnumValue = <T extends {[index: string]: string}>(myEnum: T, value: unknown): value is T[keyof T] => (
    Object.values(myEnum).some(enumValue => enumValue === value)
)
